import * as Yup from 'yup';

export const petValidationSchema = Yup.object().shape({
    nome: Yup.string().required("Nome obrigatório"),
    especie: Yup.string().required("Espécie obrigatória"),
    raca: Yup.string(),
    idade: Yup.number()
      .transform((value) => (isNaN(value) ? undefined : value))
      .min(0, "Idade inválida")
      .nullable(),
    peso: Yup.number()
      .transform((value) => (isNaN(value) ? undefined : value))
      .min(0, "Peso inválido")
      .nullable(),
    sexo: Yup.string().required("Sexo obrigatório"),
    observacoes: Yup.string(),
    foto: Yup.array(),
  });
  